module.exports = __webpack_public_path__ + "static/media/delete-icon.0682aa76.svg";